import React from "react";
import { Card } from "react-bootstrap";

function Dashboard_Card({ title, value, icon, color, bgColor, children }) {
  return (
    <Card
      className="shadow-sm border-0 h-100 text-white"
      style={{
        borderLeft: `5px solid ${color}`,
        backgroundColor: bgColor,
        borderRadius: "10px",
      }}
    >
      <Card.Body className="d-flex justify-content-between align-items-center">
        <div>
          <h6 className="text-uppercase fw-bold">{title}</h6>
          <h3 className="fw-bold mb-0">{value}</h3>
        </div>

        <div
          className="rounded-circle d-flex justify-content-center align-items-center"
          style={{
            width: "50px",
            height: "50px",
            backgroundColor: color,
            color: "white",
            fontSize: "22px",
            flexShrink: 0,
          }}
        >
          <i className={icon}></i>
        </div>
      </Card.Body>

      {children && <div className="px-5 pb-3">{children}</div>
      }
    </Card>
  );
}

export default Dashboard_Card;
